import { render, staticRenderFns } from "./TheThgList.vue?vue&type=template&id=410df4d2&scoped=true"
import script from "./TheThgList.vue?vue&type=script&lang=ts"
export * from "./TheThgList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410df4d2",
  null
  
)

export default component.exports